import { useBooleanState } from "@outschool/ui-utils";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import AddCalendarModal, { AddCalendarModalProps } from "./AddCalendarModal";

type AddCalendarButtonModalProps = {
  renderButton: (setOpen: () => void) => JSX.Element;
} & Omit<AddCalendarModalProps, "open" | "onClose">;

export default function AddCalendarButtonModal({
  renderButton,
  ...props
}: AddCalendarButtonModalProps): JSX.Element {
  const [open, setOpen, setClosed] = useBooleanState(false);
  const location = useLocation();
  useEffect(() => {
    location.query.show_calendar === "true" ? setOpen() : setClosed();
  }, [location.query, setOpen, setClosed]);

  return (
    <React.Fragment>
      {renderButton(setOpen)}
      <AddCalendarModal open={open} onClose={setClosed} {...props} />
    </React.Fragment>
  );
}
